import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ModalProvider } from './hooks/useModal';
import { HeroUIProvider } from '@heroui/system';
import Layouts from './Layouts';
import './App.css';

function App() {
  return (
    <HeroUIProvider>
      <ThemeProvider>
        <AuthProvider>
          <ModalProvider>
            <Layouts />
          </ModalProvider>
        </AuthProvider>
      </ThemeProvider>
    </HeroUIProvider>
  );
}

export default App;